import { gql } from '@apollo/client';

const ORDER_OF_PLAY_DATES = gql`
  query tournamentMatchesDates($filter: ListGroupMatchInput, $hideCompleteMatches: Boolean) {
    tournamentMatchesDates(filter: $filter, hideCompleteMatches: $hideCompleteMatches)
  }
`;
export default ORDER_OF_PLAY_DATES;
